<template>
  <div>
    <NavBar />
    <IntroPage />
    <TimeLine />
    <IntroductionCollage />
    <PubliciPage />
    <Destacados />
    <Footer />
  </div>
</template>
  
  <script>
  
  import NavBar from '@/components/NavBar.vue'
	import IntroPage from '@/components/IntroPage.vue'
  import TimeLine from '@/components/TimeLine.vue'
  import InfoMode from '@/components/InfoMode.vue'
  import Destacados from '@/components/Destacados.vue'
  import Footer from '@/components/Footer.vue'
  import PubliciPage from '@/components/PubliciPage.vue'
  import IntroductionCollage from '@/components/IntroductionCollage.vue'
  
  export default {
    name: 'HomePage',
    components:{
    NavBar,
    IntroPage,
    TimeLine,
    InfoMode,
    Destacados,
    Footer,
    PubliciPage,
    IntroductionCollage
}
  }
  </script>
  
  